export class Item {
    public label: string;
    public value: string;
    public selected?: boolean;

    constructor( label: string, value: string, selected?: boolean ){
        this.label = label;
        this.value = value;
        this.selected = selected;
    }
}
